<template>
  <div
    :class="[
      'UIElement',
      $style.NavigationItem,
      match && match.active && $style.NavigationItem__active,
      match && match.exact && $style.NavigationItem__exactActive
    ]"
    @click="onClick(item)"
  >
    <Icon
      v-if="item.icon"
      :icon="item.icon"
      :class="$style.NavigationItem_icon"
    />
    <span :class="$style.NavigationItem_label">{{ item.label }}</span>
  </div>
</template>

<script>
// import { getCurrentRouteMatch } from '../../utils'
import {Icon} from '../Icon'

export default {
  name: 'Navigation',
  components: {
    Icon
  },
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    match() {
      // return this.item &&
      //   getCurrentRouteMatch(this.$router, this.item.url, this.item.aliases)
      return null
    }
  },
  methods: {
    onClick(item) {
      if (item.url) {
        // this.$navigate(item.url)
      }
    }
  }
}
</script>

<style lang="scss" module>
@import '../../styles/variables';

.NavigationItem {
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: #212b36;
  cursor: pointer;

  &:hover {
    color: #000;

    .NavigationItem_icon {
      color: #637381;
    }
  }
}

.NavigationItem.NavigationItem__active {
  &, .NavigationItem_icon {
    color: $focusColor;
  }
}

.NavigationItem_label {
  margin: 6px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.NavigationItem_icon {
  flex: 0 0 25px;
  margin-right: 14px;
  color: #919eab;
  font-size: 20px;
}
</style>
